import Vue from 'vue';
import { SuperDate } from '@razlet/utils';
import Contract from './contract';

export default class Quota {
  data = null;
  contract = null;

  constructor (data) {
    this.data = data;

    this.contract = new Contract(data.contract);
  }

  get id () {
    return this.data.id;
  }

  get iata () {
    return this.data.iataCode;
  }

  get arrival () {
    return this.data.arrival;
  }

  get departure () {
    return this.data.departure;
  }

  get direction () {
    return `${this.departure} - ${this.arrival}`;
  }

  get weekdays () {
    return this.data.flightDayOfWeek || [];
  }

  get weekdaysNames () {
    if (!this.weekdays) return '';
    return this.weekdays.map(weekday => Vue.prototype.$localize.t(`weekdays.${weekday}.short`));
  }

  get flights () {
    return this.data.flightNumbers || [];
  }

  get expireAt () {
    return this.data.expireAt;
  }

  get beginDate () {
    return new SuperDate(this.data.begin);
  }

  get finishDate () {
    return new SuperDate(this.data.finish);
  }

  get dateRange () {
    return `${this.beginDate.date} - ${this.finishDate.date}`;
  }

  get contract () {
    return this.contract;
  }

  get volume () {
    return this.data.volume;
  }

  get weight () {
    return this.data.weight;
  }

  get notApplicable () {
    return !this.data.applicable;
  }

  get fullName () {
    return `${this.direction} | ${this.contract.contractor.name}`;
  }

  get abilityProps () {
    return {
      company: this.iata,
      departure: this.departure,
      arrival: this.arrival,
    };
  }
};
